import { Link, Outlet, NavLink, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, Boxes, Inbox, LogOut } from "lucide-react";

const navItems = [
  { to: "/admin", end: true, label: "Overview", icon: LayoutDashboard },
  { to: "/admin/systems", label: "Systems", icon: Boxes },
  { to: "/admin/leads", label: "Leads & Requests", icon: Inbox },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();

  if (user === undefined) {
    return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  }
  if (user === null || !user) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="min-h-screen flex bg-slate-50">
      <aside className="hidden md:flex w-64 flex-col bg-slate-950 text-white" data-testid="admin-sidebar">
        <Link to="/" className="px-6 h-16 flex items-center gap-3 border-b border-white/10">
          <div className="w-9 h-9 rounded-xl bg-white text-slate-900 grid place-items-center font-heading font-bold">S</div>
          <div className="leading-tight">
            <div className="font-heading font-semibold">Showroom</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-400">Admin Console</div>
          </div>
        </Link>
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm transition-colors ${
                    isActive ? "bg-[#D4AF37] text-slate-900 font-semibold" : "text-slate-300 hover:bg-white/5 hover:text-white"
                  }`
                }
                data-testid={`admin-nav-${n.label.replace(/\s+/g, "-").toLowerCase()}`}
              >
                <Icon className="w-4 h-4" />
                {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="text-xs text-slate-400 truncate">{user.email}</div>
          <button onClick={logout} className="mt-2 w-full inline-flex items-center justify-center gap-2 rounded-full bg-white/5 hover:bg-white/10 text-sm py-2" data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <div className="md:hidden bg-slate-950 text-white px-4 py-3 flex items-center justify-between">
          <Link to="/admin" className="font-heading font-semibold">Showroom Admin</Link>
          <button onClick={logout} className="text-sm text-slate-300">Logout</button>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
